// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ym3kG","scrollContainer":"styles_scrollContainer__sbAvi","textarea":"styles_textarea__niJ76","postfix":"styles_postfix__amobO"};